import { render, staticRenderFns } from "./ModalFormularioCategoriasEquivalentes.vue?vue&type=template&id=86751270&scoped=true"
import script from "./ModalFormularioCategoriasEquivalentes.vue?vue&type=script&lang=js"
export * from "./ModalFormularioCategoriasEquivalentes.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioCategoriasEquivalentes.vue?vue&type=style&index=0&id=86751270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86751270",
  null
  
)

export default component.exports